<template>
  <section class="mb-4">
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 text-center">
          <h1> Déclarer un sinistre</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class="card-body px-4 pt-4 rounded-4
              box-shadow-pink-300
              box-shadow-hover-pink-300"
            >
              <div class="row">
                <div class="col-2">
                  <v-icon
                    icon="chevron-left"
                    class="cursor-pointer"
                    @click="() => $router.back()"
                  />
                </div>
                <div class="col-8">
                  <div class="text-center">
                    <h4>Pièces à fournir</h4>
                  </div>
                </div>
                <div class="col-12 col-md-10 mx-auto">
                  <div
                    v-for="(item, index) in download"
                    :key="index"
                    class="card shadow my-3 p-1"
                  >
                    <div class="card-body d-flex flex-row justify-content-between">
                      <div class="d-flex flex-column my-auto">
                        <div class="fw-bold">
                          {{ item.label }}
                        </div>
                        <div> {{ item.description }} </div>
                      </div>
                      <div
                        class="d-flex flex-row"
                        style="min-width:220px"
                      >
                        <v-loader
                          style="min-width:180px"
                          class="btn btn-primary my-auto"
                          :next="() => downloadFile(item.link, item.label)"
                        >
                          <div class="d-flex flex-row">
                            <span
                              class="ms-auto me-1 small"
                            > Télécharger </span>
                            <v-icon
                              class="me-auto "
                              icon="download-white"
                            />
                          </div>
                        </v-loader>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-10 mx-auto">
                  <div
                    v-for="(item, index) in upload"
                    :key="index"
                    class="card shadow my-3 p-1"
                  >
                    <div class="card-body d-flex flex-row justify-content-between">
                      <div class="d-flex flex-column my-auto">
                        <div class="fw-bold">
                          {{ item.label }}
                        </div>
                        <div> {{ item.description }} </div>
                      </div>
                      <v-loader-upload
                        :index="index"
                        title="Choisir un fichier"
                        :download-link="item.link ? item.link : ''"
                        icon-color="white"
                        class="my-auto"
                        @upload="(value) => item.uploaded = value"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-10 mx-auto">
                  <v-loader
                    class="w-100"
                    title="Continuer"
                    icon="arrow-white-right"
                    :next="goToConfirmation"
                  />
                  <v-loader
                    class="w-100 mt-3"
                    color="block"
                    title="Annuler"
                    :next="cancelClaim"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  uploadMrpFire,
  uploadMrpBrokenGlass,
  uploadMrpBrokenMachine,
  uploadMrpRobbery,
  uploadMrpWater,
  uploadRcPro,
} from '@/components/claim/json';

import LoaderUpload from '@/components/common/helpers/LoaderUpload.vue';

const [
  BROKEN_GLASS,
  BROKEN_MACHINE,
  WATER,
  FIRE,
  ROBBERY,
] = [4, 5, 10, 15, 24];

export default {
  name: 'ClaimFiles',
  components: {
    'v-loader-upload': LoaderUpload,
  },
  data() {
    return {
      upload: [],
      download: [],
    };
  },
  computed: {
    productId() {
      return this.$store.getters['claim/currentProductId'];
    },
  },
  beforeMount() {
    const { type: { code } } = this.$store.state.claim;
    let files = [];

    switch (code) {
      case BROKEN_GLASS:
        files = uploadMrpBrokenGlass;
        break;
      case BROKEN_MACHINE:
        files = uploadMrpBrokenMachine;
        break;
      case WATER:
        files = uploadMrpWater;
        break;
      case FIRE:
        files = uploadMrpFire;
        break;
      case ROBBERY:
        files = uploadMrpRobbery;
        break;
      default:
        if (this.productId === 1) {
          files = uploadRcPro;
        } else {
          files = [
            {
              label: 'Veuillez ajouter tout document pouvant être utile',
              description: '',
            },
          ];
        }
        break;
    }
    this.upload = files.filter(({ upload }) => !upload);
    this.download = files.filter(({ upload }) => upload);
  },
  beforeDestroy() {
    this.$store.dispatch('claim/setValue', { attachments: [] });
  },
  methods: {
    cancelClaim() {
      this.$store.dispatch('claim/clear');
      return this.$router.push('/client/claim') || Promise.resolve();
    },
    downloadFile(downloadLink, name) {
      return this.$store.dispatch('download/downloadFromUrl', { downloadLink, name });
    },
    async goToConfirmation() {
      await this.$store.dispatch('claim/sendEmail');
      return this.$router.push('/client/claim/confirmation');
    },
  },
};
</script>
